import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AddAttachmentsService {

  constructor(private http: HttpClient) { }

  /**
   * Save attachments to the server
   * Maps to: MessageFactory.saveAttachment(URLS.saveAttachemnt, objContext)
   */
  saveAttachments(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/saveAttachmentDocuments`;
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, typeof params[key] === 'object' ? JSON.stringify(params[key]) : params[key].toString());
      }
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Load existing attachments
   * Maps to: MessageFactory.getComments(GENERAL_CONFIG.base_url+'/loadFileAttachments', params)
   */
  loadAttachments(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadFileAttachments`;
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save/Update/Delete document comments
   * Maps to: MessageFactory.getComments(GENERAL_CONFIG.base_url+'/saveDocComment', objContext)
   */
  saveDocComment(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/saveDocComment`;
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Download attachment file
   * Maps to: MessageFactory.downloadMsgAttachment(fileName, parentKey, docKey)
   */
  downloadAttachment(baseUrl: string, fileName: string | null, parentKey: string, docKey: string, clientKey: string, ssoId: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/getAPIAuthToken`).pipe();
  }

  /**
   * Get API auth token for download
   */
  getApiAuthToken(baseUrl: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/getAPIAuthToken`);
  }

  /**
   * Build download URL with auth token
   */
  buildDownloadUrl(baseUrl: string, fileName: string | null, parentKey: string, docKey: string, clientKey: string, apiToken: string, ssoId: string): string {
    let url = `${baseUrl}/downloadCommentAttachement?`;
    
    if (fileName) {
      url += `fileName=${encodeURIComponent(fileName)}&`;
    }
    if (parentKey) {
      url += `commentKey=${encodeURIComponent(parentKey)}&`;
    }
    url += `docKey=${encodeURIComponent(docKey)}&`;
    url += `client_key=${encodeURIComponent(clientKey)}&`;
    url += `apiToken=${encodeURIComponent(apiToken)}&`;
    url += `georaclehrid=${encodeURIComponent(ssoId)}`;
    
    return url;
  }

  /**
   * Get upload URL for file attachments
   */
  getUploadUrl(baseUrl: string): string {
    return `${baseUrl}/uploadCommentAttachements`;
  }

  /**
   * Remove attachment from temp folder
   * Maps to: vm.MessageFactory.CommentCrud(GENERAL_CONFIG.base_url + '/removeAttachment', objContext)
   */
  removeAttachment(baseUrl: string, fileName: string): Observable<any> {
    const url = `${baseUrl}/removeAttachment`;
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const params = {
      destDir: 'temp',
      flowFilename: fileName
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, (params as any)[key].toString());
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
